module.exports = __webpack_public_path__ + "img/b492491.jpg";